import { CONTACT, SOCIALS } from "@/config";
import { Instagram, MessageCircle, Share2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const socialIcons = {
  instagram: Instagram,
};

export const SocialDock = () => (
  <div data-testid="social-dock" className="fixed bottom-6 right-6 z-40">
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="social-dock-toggle"
          aria-label="Open social media menu"
          className="bg-forest text-white rounded-lg p-3.5 shadow-lg hover:bg-forest-dark transition-colors duration-200"
        >
          <Share2 size={18} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="top"
        align="end"
        sideOffset={10}
        data-testid="social-dock-menu"
        className="w-64 rounded-xl border-line-2 p-2"
      >
        <DropdownMenuLabel className="label-caps text-muted-g">Follow Room 9</DropdownMenuLabel>
        {SOCIALS.map((s) => {
          const Icon = socialIcons[s.id];
          return (
            <DropdownMenuItem key={s.id} asChild className="cursor-pointer rounded-lg">
              <a
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-dock-${s.id}`}
                className="flex items-center gap-3 px-2 py-2.5"
              >
                <Icon size={15} className="text-forest" />
                <span className="font-mono text-xs">{s.handle}</span>
              </a>
            </DropdownMenuItem>
          );
        })}
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild className="cursor-pointer rounded-lg">
          <a
            href={CONTACT.whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-dock-whatsapp"
            className="flex items-center gap-3 px-2 py-2.5 bg-emerald-600 !text-white hover:!bg-emerald-700"
          >
            <MessageCircle size={15} />
            <span className="font-mono text-xs">WhatsApp: {CONTACT.phoneDisplay}</span>
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
);
